import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-online-application-one',
  templateUrl: './online-application-one.component.html',
  styleUrls: ['./online-application-one.component.scss']
})
export class OnlineApplicationOneComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
